import { Utils } from 'cc-common';
import { Exclude, Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class AccOpenStatusItemResultDto {
    @Type(() => Date)
    receivedDate: Date;

    @Type(() => Date)
    dueDate: Date;

    @Type(() => Date)
    modifiedOn: Date;

    allowArchitecturalBoardApproval: boolean;
    allowFinaliseItem: boolean;
    allowUnFinaliseItem: boolean;
    selectedStatusCode: string;
    accId: number;
    accItemId: number;
    communityId: number;
    community: string;
    location: string;
    customerId: string;
    ownerName: string;
    propertyAddress: string;
    project: string;
    description: string;
    statusDisplayText: string;
    category: string;
    documentCount: number;
    emailInboxCount: number;
    hasDiscussionNotes: boolean;

    @Type(() => UserNameDisplayResultDto)
    assignedTo: UserNameDisplayResultDto;

    @Type(() => UserNameDisplayResultDto)
    updatedBy: UserNameDisplayResultDto;

    @Type(() => KeyValueResultDto)
    customResponses: KeyValueResultDto[];

    allowSendEmailToOwner: boolean;
    allowanceCategory: string;
    allowanceSubCategory: string;
    depositType: string;
    depositStatus: string;
    responseToOwner: string;
    depositAmount: number;
    depositRef: string;
    requiredDeposit: number;

    @Type(() => Date)
    committeeSubmitDate: Date;

    get assignedToDisplayText(): string {
        return Utils.notNullAndDefined(this.assignedTo) ? this.assignedTo.displayName : '';
    }

    get updatedByDisplayText(): string {
        return Utils.notNullAndDefined(this.updatedBy) ? this.updatedBy.displayName : '';
    }

    // Transient variable
    @Exclude()
    allowChangeOwner: boolean;
    @Exclude()
    allowChangeStatus: boolean;
    @Exclude()
    allowSendEmailReminder: boolean;
    @Exclude()
    allowViewEdit: boolean;
}
